import React from 'react';
import { columns } from 'components/modules/accounting/invoices/mappings';
import DataList from 'components/ui/DataList';
import { withTranslation } from 'react-i18next';
class InvoiceList extends React.Component {
    constructor(props) {
        super(props);
        this.handleSelection = (row, isSelect) => {
            this.setState((prevState) => {
                let selectedInvoiceIds;
                if (isSelect) {
                    selectedInvoiceIds = [...prevState.selectedInvoiceIds, row._id];
                }
                else {
                    selectedInvoiceIds = prevState.selectedInvoiceIds.filter((x) => x !== row._id);
                }
                return {
                    selectedInvoiceIds,
                };
            }, () => {
                this.props.updateSelectedInvoices(this.state.selectedInvoiceIds);
            });
        };
        this.handleSelectAll = (isSelect, rows) => {
            const ids = rows.map((r) => r._id);
            if (isSelect) {
                this.setState(() => ({
                    selectedInvoiceIds: ids,
                }));
            }
            else {
                this.setState(() => ({
                    selectedInvoiceIds: [],
                }));
            }
            this.props.updateSelectedInvoices(ids);
        };
        this.state = {
            selectedInvoiceIds: [],
            hiddenColumns: [], // Not using this yet, but might be needed in the future
            invoices: this.props.invoices || [],
            showSendEmailModal: false,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.invoices !== nextProps.invoices) {
            this.setState({ invoices: nextProps.invoices });
        }
    }
    render() {
        console.log('this.props', this.props);
        return (React.createElement(DataList, { showHeaders: true, select: true, paginate: true, selected: this.state.selectedInvoiceIds, hover: true, striped: true, data: this.state.invoices, columns: columns, hiddenColumns: this.state.hiddenColumns, onSelect: (selectedInvoices, checked) => this.handleSelection(selectedInvoices, checked), onSelectAll: (checked, selectedInvoices) => this.handleSelectAll(checked, selectedInvoices), noDataIndication: this.props.loading && this.props.t('LOADING'), total: this.props.total, pages: this.props.pages, perPage: this.props.perPage, page: this.props.page, onPaginationSelect: this.props.onPaginationSelect }));
    }
}
export default withTranslation()(InvoiceList);
